export default {
    goodsAudit: {
        Ps1: 'You are deleting',
        Ps2: 'Do you want to continue',
        page: {
            ProductCategory: 'Product Category',
            Category: 'Category',
            Approvaltime: 'Date Approved'
        },
        detail: {
            Pass: 'Pass',
            Reject: 'Reject',
            BeforeModification: 'Before Modification',
            ProductDetails: 'Product Details Review',
            AfterModification: 'After Modification',
            BasicInformation: 'Account Information',
            attribute: 'SKU Attribute',
            price: 'SKU Price',
            Details: 'SKU Details',
            material: 'Product Material',
            status: 'Approval Status:',
            comments: 'Review Comments:',
            packageSku: 'Package SKU',

            description: 'Product Description',
            Submitted: 'Submitted By:',
        }
    }
};
